import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../utils/config';

// Derive the server root (strip trailing /api)
const SERVER_ROOT = BASE_URL.replace(/\/api\/?$/, '');

/**
 * Fetches active sponsors for a given screen type.
 * Region filtering is handled automatically by the backend using the client's IP address.
 * @param {'offer'|'demand'} screen
 * @returns {{ getSponsor: (index: number) => object|null }}
 */
export function useSponsors(screen) {
  const { i18n } = useTranslation();
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    const language = (i18n.language || 'en').toUpperCase();
    const url = `${SERVER_ROOT}/api/public/sponsors?screen=${screen}&language=${language}`;
    fetch(url)
      .then(res => res.json())
      .then(data => setSponsors(data?.sponsors || []))
      .catch(() => setSponsors([]));
  }, [screen, i18n.language]);

  // One-to-one: slot 0 → sponsors[0], slot 1 → sponsors[1], etc.
  // Returns null if no sponsor exists for that slot (show "space available" placeholder)
  const getSponsor = (index) => sponsors[index] ?? null;

  return { getSponsor };
}
